import cx from 'classnames'

const alertClasses = {
  danger: 'tw:border-status-danger-border tw:bg-status-danger-surface tw:text-status-danger-foreground',
  info: 'tw:border-status-info-border tw:bg-status-info-surface tw:text-status-info-foreground',
  primary: 'tw:border-status-neutral-border tw:bg-status-neutral-surface tw:text-status-neutral-foreground',
  success: 'tw:border-status-success-border tw:bg-status-success-surface tw:text-status-success-foreground',
  warning: 'tw:border-status-warning-border tw:bg-status-warning-surface tw:text-status-warning-foreground',
}

export const Alert = ({ children, className, color = 'primary', role, ...props }) => {
  const defaultRole = color === 'danger' || color === 'warning' ? 'alert' : 'status'

  return (
    <div className={cx('tw:mb-4 tw:rounded-input tw:border tw:px-4 tw:py-3 tw:text-base', alertClasses[color], className)} role={role || defaultRole} {...props}>{children}</div>
  )
}
